<template>
  <div v-if="isMounted && businessProfileData">
    <vx-card class="mb-base mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon icon="BriefcaseIcon" svgClasses="w-5 h-5" class="mr-2 text-primary" />
            <span class="font-medium text-lg leading-none bold">Información general</span>
          </div>
          <vs-divider />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-list>
            <vs-list-item title="Giro mercantil, actividad u objeto social">{{
              this.businessProfileData.business_activity
              }}</vs-list-item>
            <vs-list-item title="Nacionalidad">{{ this.businessProfileData.nationality }}</vs-list-item>
            <vs-list-item title="País de residencia">{{ this.businessProfileData.country }}</vs-list-item>
            <vs-list-item title="Teléfono">{{ this.businessProfileData.phone }}</vs-list-item>
            <vs-list-item title="Fecha de constitución">{{ this.businessProfileData.constitution_date }}</vs-list-item>
          </vs-list>
        </div>
      </div>
    </vx-card>

    <vx-card class="mb-base mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon icon="BriefcaseIcon" svgClasses="w-5 h-5" class="mr-2 text-primary" />
            <span class="font-medium text-lg leading-none bold">Representante legal</span>
          </div>
          <vs-divider />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-list>
            <vs-list-item title="Nombre">{{
              this.businessProfileData.legal_representative_data.legal_representative_name}}</vs-list-item>
            <vs-list-item title="CURP">{{ this.businessProfileData.legal_representative_data.curp }}</vs-list-item>
            <vs-list-item title="RFC">{{ this.businessProfileData.legal_representative_data.rfc }}</vs-list-item>
          </vs-list>
        </div>
      </div>
    </vx-card>

    <vx-card class="mb-base mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon icon="BriefcaseIcon" svgClasses="w-5 h-5" class="mr-2 text-primary" />
            <span class="font-medium text-lg leading-none bold">Estructura accionaria</span>
          </div>
          <vs-divider />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-list>
            <div v-for="(stakeholder, i) in this.businessProfileData.stakeholders" :key="i">
              <vs-list-item :title="stakeholder.name">{{ prcgFormat(stakeholder.share, 2) }}</vs-list-item>
            </div>
          </vs-list>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper";

export default {
  name: "InvestorPmResumeData",
  components: {},
  mixins: [formatHelper],

  data() {
    return {
      isMounted: false,
      errorMssg: null,
      colClass: "vx-col md:w-1/4 sm:w-full w-full mb-5",
      colClassFull: "vx-col w-full mb-5",
      businessProfileData: null
    };
  },
  mounted() {
    this.isMounted = true;
  },
  async beforeMount() {
    this.showLoading(true);
    await this.getInvestorData();
    this.showLoading(false);
  },
  methods: {
    async getInvestorData() {
      try {
        let response = await axios.get(`api/v2/investor/${this.InvestorId}/resume-data-profile`);
        this.businessProfileData = response.data;
      }
      catch (e) {
        this.warn(e);
        this.failed = true;
      }
    },
    showError(e) {
      this.warn(e);
      let err = "Ha ocurrido un error con la operación, intente más tarde";
      if (e.response && e.response.data && e.response.data.error) {
        err = e.response.data.error;
      }
      this.errorMssg = err;
      setTimeout(() => this.errorMssg = null, 5000);
    },
    hasError(val) {
      return this.errors.has(val);
    },
    errorText(val) {
      return this.errors.first(val);
    },
    isSuccess(val) {
      let ff = this.fields[val];
      return ff && ff.required && ff.valid;
    },
  },
}
</script>
<style scoped>
table {
  border-collapse: separate;
  border-spacing: .5em;
}
</style>